import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93c169c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "title-contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_5 = { class: "box-contents" }
const _hoisted_6 = { class: "text box-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "售后服务", -1))
const _hoisted_8 = { class: "type" }
const _hoisted_9 = {
  key: 0,
  class: "type-status"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "post-sale-status" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-guanbi2-fill1" })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-status" }, "退款失败", -1))
const _hoisted_12 = { class: "title-info" }
const _hoisted_13 = { class: "title-info-right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-info-right" }, "主动撤销，退款申请关闭", -1))
const _hoisted_15 = {
  key: 1,
  class: "type-status"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-status" }, "等待客服处理", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-info" }, " 您已成功发起退款申请，请耐心等待客服处理，我们将在1-3个工作日内审核您的申请。 ", -1))
const _hoisted_18 = {
  key: 2,
  class: "type-status"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-status" }, "退款申请审核通过", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-info" }, " 客服已同意了您的退款申请，请耐心等待，我们将于1-3个工作日将钱款退入您的付款账户 ", -1))
const _hoisted_21 = {
  key: 3,
  class: "type-status"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "post-sale-status" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-chenggong11" })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-status" }, "退款成功", -1))
const _hoisted_24 = { class: "title-info" }
const _hoisted_25 = { class: "title-info-right" }
const _hoisted_26 = { class: "title-info-right" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-info" }, " 客服已同意了您的退款申请，请耐心等待，我们将于1-3个工作日将钱款退入您的付款账户 ", -1))
const _hoisted_28 = {
  key: 4,
  class: "type-status"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-status" }, "买家退货", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-info" }, " 您已成功发起退款申请，请耐心等待客服处理，我们将在1-3个工作日内审核您的申请。 ", -1))
const _hoisted_31 = {
  key: 5,
  class: "type-status"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "post-sale-status" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-guanbi2-fill1" })
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-status" }, "货物验收不通过", -1))
const _hoisted_34 = {
  key: 6,
  class: "type-status"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-status" }, "退款申请审核未通过", -1))
const _hoisted_36 = { class: "title-info" }
const _hoisted_37 = { class: "title-info-right" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "驳回了退款申请", -1))
const _hoisted_39 = {
  key: 8,
  class: "type-history"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "history-title" }, "协商历史", -1))
const _hoisted_41 = { class: "history-list" }
const _hoisted_42 = {
  key: 0,
  class: "history-list-item"
}
const _hoisted_43 = { class: "item-title" }
const _hoisted_44 = { class: "item-info" }
const _hoisted_45 = { class: "item-time" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看更多", -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "box-right" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "退款/退货商品", -1))
const _hoisted_50 = { class: "add-goods" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-Vector2" }, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系售后客服", -1))
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]

import { ref, reactive, getCurrentInstance, onMounted } from "vue"
import HtmlFooter from "@/components/HtmlFooter.vue"
import HomeHead from "@/components/HomeHead.vue"
import { orderApi, userApi } from "@/service/api"
import CurrentAddress from "@/components/common/CurrentAddress.vue"
import PostSaleGoods from "@/components/order/PostSaleGoods.vue"
import PostStep from "@/components/order/postsale/PostStep.vue"
import PostCancel from "@/components/order/postsale/PostCancel.vue"
import PostButton from "@/components/order/postsale/PostButton.vue"
import { PostSale } from "@/utils/apitype/postSaleType"
import dateFormat from "@/utils/dateFormat"
import { useRoute } from "vue-router"
import { shouhoukefu, shouqiankefu } from "@/utils/alert"


export default /*#__PURE__*/_defineComponent({
  __name: 'PostSaleStatus',
  setup(__props) {

const params = useRoute()

let PostSaleInfo = reactive(new PostSale())
let orderId = parseInt(params.params.orderid as string)
let goodsId = parseInt(params.params.goodsid as string)
let orderNo = params.params.orderno as string

let isShowMore = ref(false)
let handleShowMore = () => {
  isShowMore.value = !isShowMore.value
}
const payList = ["齿轮币", "微信", "支付宝", "对公"]
let getPayType = (val: number) => {
  return payList[val]
}

let getPostInfo = () => {
  orderApi.getPostSaleInfo(orderId, orderNo, goodsId).then((res: any) => {
    PostSaleInfo.info = res.datas
    PostSaleInfo.goodsList = res.datas.goodsList
    PostSaleInfo.historyList = res.datas.history
  })
}

onMounted(() => {
  getPostInfo()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HomeHead),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CurrentAddress, null, {
          address: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" > 售后服务")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_unref(PostSaleInfo).info.status == 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("p", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, "退款关闭时间：" + _toDisplayString(_unref(dateFormat).dateFormat(
                    _unref(PostSaleInfo).info.ftime * 1000,
                    "yyyy-MM-dd hh:mm:ss"
                  )), 1),
                  _hoisted_14
                ])
              ]))
            : _createCommentVNode("", true),
          (
              _unref(PostSaleInfo).info.status == 0 &&
              _unref(PostSaleInfo).info.sales_status == 0
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _createVNode(PostButton, {
                  goodsid: _unref(goodsId),
                  orderid: _unref(orderId),
                  orderno: _unref(orderNo)
                }, null, 8, ["goodsid", "orderid", "orderno"]),
                (_unref(PostSaleInfo).info.id > 0)
                  ? (_openBlock(), _createBlock(PostCancel, {
                      key: 0,
                      id: _unref(PostSaleInfo).info.id
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (
              _unref(PostSaleInfo).info.status == 1 &&
              _unref(PostSaleInfo).info.sales_status == 0
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _hoisted_19,
                _hoisted_20,
                _createVNode(PostButton, {
                  goodsid: _unref(goodsId),
                  orderid: _unref(orderId),
                  orderno: _unref(orderNo)
                }, null, 8, ["goodsid", "orderid", "orderno"]),
                (_unref(PostSaleInfo).info.id > 0)
                  ? (_openBlock(), _createBlock(PostCancel, {
                      key: 0,
                      id: _unref(PostSaleInfo).info.id
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (
              _unref(PostSaleInfo).info.status == 3 &&
              _unref(PostSaleInfo).info.sales_status == 0
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _createElementVNode("p", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, "退款成功时间：" + _toDisplayString(_unref(dateFormat).dateFormat(
                    _unref(PostSaleInfo).info.ftime * 1000,
                    "yyyy-MM-dd hh:mm:ss"
                  )), 1),
                  _createElementVNode("span", _hoisted_26, "退款金额：¥" + _toDisplayString(_unref(PostSaleInfo).info.money), 1),
                  _createElementVNode("span", null, "钱款去向：已退回至您的" + _toDisplayString(_unref(getPayType)(_unref(PostSaleInfo).info.pay_type as number)) + "账户", 1)
                ]),
                _hoisted_27
              ]))
            : _createCommentVNode("", true),
          (
              _unref(PostSaleInfo).info.status == 2 &&
              _unref(PostSaleInfo).info.sales_status == 0
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _hoisted_29,
                _hoisted_30,
                _createVNode(PostButton, {
                  goodsid: _unref(goodsId),
                  orderid: _unref(orderId),
                  orderno: _unref(orderNo)
                }, null, 8, ["goodsid", "orderid", "orderno"]),
                (_unref(PostSaleInfo).info.id > 0)
                  ? (_openBlock(), _createBlock(PostCancel, {
                      key: 0,
                      id: _unref(PostSaleInfo).info.id
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (
              _unref(PostSaleInfo).info.sales_status == 1 &&
              _unref(PostSaleInfo).info.signed == 2
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                _hoisted_33,
                (_unref(PostSaleInfo).info.id > 0)
                  ? (_openBlock(), _createBlock(PostCancel, {
                      key: 0,
                      id: _unref(PostSaleInfo).info.id
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (
              _unref(PostSaleInfo).info.sales_status == 1 &&
              _unref(PostSaleInfo).info.signed != 2
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("p", _hoisted_36, [
                  _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(dateFormat).dateFormat(
                  _unref(PostSaleInfo).info.ftime * 1000,
                  "yyyy-MM-dd hh:mm:ss"
                )), 1),
                  _hoisted_38
                ]),
                _createVNode(PostButton, {
                  goodsid: _unref(goodsId),
                  orderid: _unref(orderId),
                  orderno: _unref(orderNo)
                }, null, 8, ["goodsid", "orderid", "orderno"]),
                (_unref(PostSaleInfo).info.id > 0)
                  ? (_openBlock(), _createBlock(PostCancel, {
                      key: 0,
                      id: _unref(PostSaleInfo).info.id
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(PostSaleInfo).info.status && _unref(PostSaleInfo).info.status != 4)
            ? (_openBlock(), _createBlock(PostStep, {
                key: 7,
                status: _unref(PostSaleInfo).info.status,
                ctime: _unref(PostSaleInfo).info.ctime,
                utime: _unref(PostSaleInfo).info.utime,
                ftime: _unref(PostSaleInfo).info.ftime,
                rtime: _unref(PostSaleInfo).info.rtime,
                signed: _unref(PostSaleInfo).info.signed,
                service_type: _unref(PostSaleInfo).info.service_type
              }, null, 8, ["status", "ctime", "utime", "ftime", "rtime", "signed", "service_type"]))
            : _createCommentVNode("", true),
          (_unref(PostSaleInfo).historyList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PostSaleInfo).historyList, (history, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "history-list-box"
                    }, [
                      ((index > 0 && _unref(isShowMore)) || index == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createElementVNode("p", _hoisted_43, _toDisplayString(history.title), 1),
                            _createElementVNode("p", _hoisted_44, _toDisplayString(history.explain), 1),
                            _createElementVNode("p", _hoisted_45, _toDisplayString(_unref(dateFormat).dateFormat(
                        history.ctime * 1000,
                        "yyyy-MM-dd hh:mm:ss"
                      )), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                (!_unref(isShowMore) && _unref(PostSaleInfo).historyList.length > 1)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "get-more",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleShowMore)()))
                    }, _hoisted_47))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _hoisted_49,
        (_unref(PostSaleInfo).goodsList.length > 0)
          ? (_openBlock(), _createBlock(PostSaleGoods, {
              key: 0,
              goodsList: _unref(PostSaleInfo).goodsList,
              status: 1,
              postSale: _unref(PostSaleInfo).info
            }, null, 8, ["goodsList", "postSale"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", {
            class: "add-goods-button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(shouhoukefu) && _unref(shouhoukefu)(...args)))
          }, _hoisted_53)
        ])
      ])
    ]),
    _createVNode(HtmlFooter)
  ]))
}
}

})